import React from 'react'
import { LuCircleCheck } from 'react-icons/lu'

import { SubmissionResult } from '@/components/misc/InviteOrRequestReferralPartners/types'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Heading } from '@/components/ui/heading'

interface Props {
  invites: SubmissionResult[]
}

const SuccessfulInvites: React.FC<Props> = ({ invites }) => (
  <Alert variant="success" className="fade-in mb-4 pb-4">
    <AlertDescription>
      <Heading size={3} className="mb-1 flex items-center gap-2 text-[16px]">
        <LuCircleCheck className="text-success text-xl" />
        Invites sent
      </Heading>

      <ul className="mb-0 pl-6">
        {invites.map((submissionResult: SubmissionResult) => (
          <li key={submissionResult.email} className="fade-in">
            {submissionResult.email}
          </li>
        ))}
      </ul>
    </AlertDescription>
  </Alert>
)

export default SuccessfulInvites
